import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import Storages from 'js-storage'
import VueHighlightJS from 'vue-highlightjs'
import CustomEvents from '@/CustomEvents'
import '@/components/globals'

Vue.config.productionTip = false;

Vue.config.performance = true;

Vue.prototype.$selectedURLS =  Storages.localStorage.isSet('APP:SelectedURLs')?Storages.localStorage.get('APP:SelectedURLs'):[];

Vue.prototype.niceIntNumber = function (num, zeroes){
  let str = '' + num
  return zeroes.substring(0, zeroes.length - str.length) + str
}

new Vue({
  CustomEvents,
  VueHighlightJS,
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')

Vue.use(VueHighlightJS)
